// Domain
import { ProofOfAddressDto } from '../dtos/proof-of-address-dto';

type ChooseYourDocuments = {
  pocket_option_is_checked: boolean;
  wealth_option_is_checked: boolean;
  selected_investment_product_ids: Array<string>;
}

type Address = {
  street: string;
  external_number: string;
  interior_number: string;
  postal_code: string;
  settlement: {
    codPais: string;
    descPais: string;
    codEstado: string;
    descEstado: string;
    codLocalidad: string;
    codMunicipio: string;
    codigoPostal: string;
    descLocalidad: string;
    descMunicipio: string;
  };
  municipality: {
    codPais: string;
    codEstado: string;
    codMunicipio: string;
    descMunicipio: string;
  };
  state: {
    codestado: string;
    descestado: string;
    codpais: string;
  };
  country: {
    descpais: string;
    codpais: string;
  };
}

export default class State {
  choose_your_documents_data: ChooseYourDocuments = {
    pocket_option_is_checked: false,
    wealth_option_is_checked: false,
    selected_investment_product_ids: [],
  };

  address: Address = {
    street: '',
    external_number: '',
    interior_number: '',
    postal_code: '',
    settlement: {
      codPais: '',
      descPais: '',
      codEstado: '',
      descEstado: '',
      codLocalidad: '',
      codMunicipio: '',
      codigoPostal: '',
      descLocalidad: '',
      descMunicipio: '',
    },
    municipality: {
      codPais: '',
      codEstado: '',
      codMunicipio: '',
      descMunicipio: '',
    },
    state: {
      codestado: '',
      descestado: '',
      codpais: '',
    },
    country: {
      descpais: 'MÉXICO',
      codpais: '412',
    },
  }

  proof_of_address_file: File | null = null;

  proof_of_address: ProofOfAddressDto = {
    name: '',
    mime_type: '',
    file_data: '',
  };
}
